/**
 * Supabase edge function for logging affiliate clicks.
 * Used by BestDealBanner, FirmTableRow, and FirmDetail.
 */
export const AFFILIATE_CLICK_URL = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/log-affiliate-click`;
